jQuery(document).ready(function ($) {
  // fplay video in backgrounf
  // var video = document.getElementById("bg-video");
  // video.autoplay = true;
  // video.load();

  // fonctions pour savoir si un element existe
  jQuery.fn.exists = function () {
    return jQuery(this).length > 0;
  };

  // images qui suivent le curseur
  if ($(".nav__thumb").exists()) {
    $("body").mousemove(function (e) {
      $(".nav__thumb").stop();
      handleMouseMove(e);
    });
    function handleMouseMove(event) {
      var x = event.pageX,
        y = event.pageY;
      $(".nav__thumb").animate(
        {
          left: x,
          top: y,
        },
        1
      );
    }
  }

  // ajout de classe au changement de page
  window.onbeforeunload = function (e) {
    $("#panel").addClass("hide");
    $("#body").addClass("load");
  };

  // bouton panel
  $("#panel-button").click(function () {
    $(this).toggleClass("hide");
    $("#panel").toggleClass("hide");
    $("#full-intro").toggleClass("hide");
  });

  // full intro
  if ($(".full-intro").exists()) {
    setTimeout(function () {
      $(".full-intro").addClass("hide");
    }, 2000);
    setTimeout(function () {
      $(".full-intro").addClass("hide-f");
    }, 2300);
    $(".full-intro").click(function () {
      $(".full-intro").addClass("hide");
      setTimeout(function () {
        $(".full-intro").addClass("hide-f");
      }, 300);
    });
  }

  // fast click
  $(function () {
    FastClick.attach(document.body);
  });

  redimensionnement();
  // scripts lancés lors d'un redimensionnement
  window.addEventListener("resize", redimensionnement, false);
});

// Fonction exécutée au redimensionnement
function redimensionnement() {
  if ("matchMedia" in window) {
    // Détection
    if (window.matchMedia("(max-width:800px)").matches) {
      // menu mobile
      $(".primary-nav, .primary-nav a").click(function (e) {
        if (!$("#panel").hasClass("hide")) {
          $("#panel").toggleClass("hide");
          $("#panel-button").toggleClass("hide");
          return false;
        }
      });
    }
  }
}

// Open External Links In New Window

// $("a").each(function () {
//   var a = new RegExp("/" + window.location.host + "/");
//   if (!a.test(this.href)) {
//     $(this).click(function (event) {
//       event.preventDefault();
//       event.stopPropagation();
//       window.open(this.href, "_blank");
//     });
//   }
// });
